// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"f6701a83","506":"f86e4b18","707":"490df2d7"}[chunkId] + ".js";
};